export default function IconClose({ className }) {
    return (
        <svg
            className={className}
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M19.7073 4.29275C19.3412 3.92663 18.7621 3.90404 18.3694 4.22439L18.2932 4.29275L12.0002 10.5857L5.70727 4.29275L5.63109 4.22439C5.23832 3.90404 4.65932 3.92663 4.2932 4.29275C3.92709 4.65887 3.90449 5.23787 4.22484 5.63064L4.2932 5.70681L10.5862 11.9998L4.2932 18.2927L4.22484 18.3689C3.90449 18.7617 3.92709 19.3407 4.2932 19.7068C4.65932 20.0729 5.23832 20.0955 5.63109 19.7752L5.70727 19.7068L12.0002 13.4138L18.2932 19.7068L18.3694 19.7752C18.7621 20.0955 19.3412 20.0729 19.7073 19.7068C20.0734 19.3407 20.096 18.7617 19.7756 18.3689L19.7073 18.2927L13.4143 11.9998L19.7073 5.70681L19.7756 5.63064C20.096 5.23787 20.0734 4.65887 19.7073 4.29275Z"
                fill="currentColor"
            />
        </svg>
    );
}
